import { render } from "./LogoFlowsFull.vue?vue&type=template&id=b024e4c6&scoped=true"
import script from "./LogoFlowsFull.vue?vue&type=script&lang=js"
export * from "./LogoFlowsFull.vue?vue&type=script&lang=js"

import "./LogoFlowsFull.vue?vue&type=style&index=0&id=b024e4c6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b024e4c6"]])

export default __exports__